export default "__VITE_ASSET__CFJCvkf2__"